export const getInterests = state => state.interest.interestList;
